import { render, staticRenderFns } from "./EstatusRecepcionSidebar.vue?vue&type=template&id=0a19e796&scoped=true"
import script from "./EstatusRecepcionSidebar.vue?vue&type=script&lang=js"
export * from "./EstatusRecepcionSidebar.vue?vue&type=script&lang=js"
import style0 from "./EstatusRecepcionSidebar.vue?vue&type=style&index=0&id=0a19e796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a19e796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VListItemAvatar,VListItemContent,VListItemTitle,VSelect})
